import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => {
  return {
    screenshotContainer: ({size}) => {

      let width = 0
      let height = 0

      if(size == 'small') {
        width = 67
        height = 50
      }

      return {
        border: '1px solid #000',
        width: `${width}px`,
        height: `${height}px`,
        boxShadow: '5px 5px 10px 0px rgba(153,153,153,1)',
        textAlign: 'center',
        '& > img': {
          height: `${height-2}px`,
        }
      }
    },
  }
})

const WebsiteScreenshot = ({
  image,
  size = 'small',
}) => {

  const classes = useStyles({
    size,
  })

  return (
    <div className={ classes.screenshotContainer }>
      <img
        src={ image || '/img/favicon.png' }
      />
    </div>
  )
}

export default WebsiteScreenshot
